import { render } from "./EditResumeComponent.vue?vue&type=template&id=3eb2baa4&scoped=true"
import script from "./EditResumeComponent.vue?vue&type=script&lang=js"
export * from "./EditResumeComponent.vue?vue&type=script&lang=js"

import "./EditResumeComponent.vue?vue&type=style&index=0&id=3eb2baa4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3eb2baa4"]])

export default __exports__